import { render, staticRenderFns } from "./MarketDetail.vue?vue&type=template&id=702af402&scoped=true"
import script from "./MarketDetail.vue?vue&type=script&lang=js"
export * from "./MarketDetail.vue?vue&type=script&lang=js"
import style0 from "./MarketDetail.vue?vue&type=style&index=0&id=702af402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702af402",
  null
  
)

export default component.exports